import React from 'react';
import Page from '~/components/Page';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBackIos } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    marginTop: 40,
  },
  headerImg: {
    textAlign: 'center',
    height: 50,
    [theme.breakpoints.down('sm')]: {
      height: 30,
    },
  },
  headerContent: {
    textAlign: 'center',
    fontSize: 30,
    margin: '40px auto',
    [theme.breakpoints.down('sm')]: {
      position: 'static',
      fontSize: 20,
      margin: '20px auto',
    },
    position: 'relative',
  },
  headerContentTitle: {
    color: '#333243',
    fontWeight: 900,
  },
  headerBackto: {
    [theme.breakpoints.down('sm')]: {
      top: 20,
      left: 10,
      fontSize: 15,
    },
    position: 'absolute',
    left: 0,
    top: 10,
    color: '#333243',
    fontSize: 18,
    display: 'flex',
    alignItems: 'center',
  },
}));

const StudentDiscount = () => {
  const classes = useStyles();
  return (
    <Page name='connect-student-discount' className={classes.pageContainer} hideFooter={true}>
      <div className={classes.headerImg}>
        <img src='/chowbus-logos/chowbus-logo-text.png' height='100%' />
        <div></div>
      </div>
      <div className={classes.headerContent}>
        <div className={classes.headerContentTitle}>Chowbus Student Discount</div>
        <a href='/' className={classes.headerBackto}>
          <ArrowBackIos style={{ fontSize: '20px', color: '#e00051' }} />
          <span>Back To Chowbus</span>
        </a>
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: `<script data-iframe='https://connect.studentbeans.com/v4/chowbus/us' data-load='connect' id='stb_root' src='https://cdn.studentbeans.com/third-party/all.js'></script>`,
        }}></div>
    </Page>
  );
};

export default StudentDiscount;

export async function getStaticProps() {
  return {
    props: {},
  };
}
